<div #divSupplierChild>
  <supplier-registration-form #supplierChild class="block" *ngIf="!isSubmitSucceeded"
    [SupplierIdInput]="selectedSupplierId" 
    [CategoryIdInput]="0" 
    [IsInActivateStepInput]="isInActivateStepInput">
  </supplier-registration-form>
</div>
<div *ngIf="!isRequestHistory && !isSubmitSucceeded">
  <ng-container #supplierRegistrationActivateForm>
    <div class="form-group">
        <button type="button" class="btn SCAcustomBtn" (click)="submit()">{{'ADMIN_USER.SUPPPLIER_FORMS.SubmitActivate'| translate}}</button>
      </div> 
  </ng-container>
</div>

<!-- Activate Confirmation Success -->
<div *ngIf="isSubmitSucceeded && !isTaskCompletedByAnotherUser" class="alert alert-success" role="alert">
    <div class="alignC">
        <i class="icon-success"></i>
      <p>{{'ADMIN_USER.SUPPPLIER_FORMS.AccountActivated'| translate}}</p>
      <p>
          {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
          <a href="{{myTasksUrl}}">
            {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
          </a>
        </p>
    </div>
  </div>
<!-- Activate Fail -->
<div *ngIf="submitFail" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>
    <hr>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
    </p>
  </div>
</div>

<!-- Task Completed By Another User Warning -->
<div *ngIf="isTaskCompletedByAnotherUser" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-warning"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.TaskCompletedByAnotherUser' | translate}}</p>
    <p>
      {{'ADMIN_USER.SUPPPLIER_FORMS.GoBackTo'| translate}}
      <a href="{{myTasksUrl}}">
        {{'ADMIN_USER.SUPPPLIER_FORMS.MyTasks'| translate}}
      </a>
    </p>
  </div>
</div>
